module.exports = __webpack_public_path__ + "img/myHead.913620e4.png";